module.exports = __webpack_public_path__ + "fonts/ef7c663.woff2";